const DataType = {
  customProperties: 'CUSTOM_PROPERTIES',
  fullLibrary: 'FULL_LIBRARY',
  homePage: 'HOMEPAGE',
  calendar: 'CALENDAR_DATA_v2',
  checkpointAwaitingReview: 'CHECKPOINT_AWAITING_REVIEW'
};

export { DataType };
export default DataType;
